import { Translate } from "components/common/Translate/Translate";
import type { SelectedColor } from "store/features/colorPicker/types";
import { ColorFormats } from "./ColorFormats/ColorFormats";
import { ColorInfoCard } from "./ColorInfoCard/ColorInfoCard";
import { useColorCodes } from "./useColorCodes";
import { ColorComponents } from "./ColorInfoCard/ColorComponents/ColorComponents";

interface ColorCodesProps {
    selectedColor: SelectedColor;
}

export const ColorCodes = ({ selectedColor }: ColorCodesProps) => {
    const { selectedColorFormat, setSelectedColorFormat, source } = useColorCodes();
    return (
        <div className="flex flex-col gap-8">
            <div className="flex flex-col gap-2">
                <span className="font-semibold text-lg">
                    <Translate keyName="hex-code" />
                </span>
                <ColorInfoCard color={selectedColor} colorFormat="hex" source={source} />
            </div>
            <div className="flex flex-col gap-2">
                <span className="font-semibold text-lg">
                    <Translate keyName="other-color-formats" />
                </span>
                <ColorFormats
                    selectedColorFormat={selectedColorFormat}
                    setSelectedColorFormat={setSelectedColorFormat}
                />
                <ColorInfoCard color={selectedColor} colorFormat={selectedColorFormat} source={source} />
            </div>
            <ColorComponents hex={selectedColor.hex} format={selectedColorFormat} />
        </div>
    );
};
